import React, { FC, memo } from 'react'

import { Txt, Tooltip } from 'src/components/atoms'

type Props = {
  children: React.ReactElement<any, any>
}

export const CreateProjectTooltip: FC<Props> = memo(({ children }) => {
  return (
    <Tooltip
      placement="top"
      content={
        <Txt sizeType="s">
          新しいROOV compassプロジェクトを作成します。
          <br />
          WORKSでの役割が「管理者」の場合はプロジェクトを
          <br />
          作成が可能で、作成者は自動的にROOV compassの
          <br />
          プロジェクト管理者としてアサインされます。
        </Txt>
      }
    >
      {children}
    </Tooltip>
  )
})
